import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { BASE_URL } from "../../config/config";

export default function MyOrders() {
  const [orders, setOrders] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [fetchError, setFetchError] = useState(false);

  const fetchData = async (token) => {
    try {
      const response = await axios.post(
        `${BASE_URL}/order`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setOrders(response.data.orderHistory || []);
      setFetchError(false);
    } catch (error) {
      setFetchError(true);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const token = sessionStorage.getItem("authToken");
    if (token) {
      fetchData(token);
    } else {
      setIsLoading(false);
    }
  }, []);

  const renderStatus = (status) => {
    switch (status) {
      case "SUCCESS":
        return <span className="badge bg-success">Success</span>;
      case "PENDING":
        return <span className="badge bg-warning text-dark">Pending</span>;
      case "FAILED":
      case "REJECTED":
        return <span className="badge bg-danger">Rejected</span>;
      default:
        return <span className="badge bg-secondary">Unknown</span>;
    }
  };

  return (
    <div className="container py-4">
      <h2 className="mb-4 fw-bold">My Orders</h2>

      {isLoading ? (
        <p>Loading orders...</p>
      ) : fetchError ? (
        <div className="alert alert-danger">Error loading your orders.</div>
      ) : orders.length === 0 ? (
        <div className="text-center p-5 bg-light rounded shadow-sm fade-in-up">
          <img
            src="https://cdn-icons-png.flaticon.com/512/4076/4076549.png"
            alt="No orders"
            className="floating-image"
            style={{ maxWidth: "150px", marginBottom: "10px" }}
          />

          <h4 className="mb-2 fw-semibold text-secondary">No Orders Yet</h4>
          <p className="text-muted mb-3">
            Looks like you haven’t placed any orders yet. Start shopping now!
          </p>
          <Link to="/shop" className="btn btn-outline-dark px-4">
            <i className="bi bi-cart-plus me-2"></i>Shop Now
          </Link>
        </div>
      ) : (
        orders.map((order) => {
          const parsedRate = JSON.parse(order.price)[0];
          const formattedDate = new Date(
            order.purchase_date
          ).toLocaleDateString("en-IN", {
            month: "short",
            day: "2-digit",
            year: "numeric",
          });

          return (
            <div
              key={order.id}
              className="d-flex justify-content-between align-items-center bg-white shadow-sm rounded p-3 mb-3"
            >
              <div className="d-flex align-items-center">
                <img
                  src={`${BASE_URL}/uploads/${order.image}`}
                  alt={order.product_name}
                  style={{
                    width: "70px",
                    height: "70px",
                    objectFit: "contain",
                  }}
                  className="me-3"
                />
                <div>
                  <h6 
                    className="text-decoration-none text-muted d-block fw-medium text-truncate"
                     style={{ maxWidth: "180px" }} 
                    >
                    {order.product_name} - 1 Item
                  </h6>
                  <small className="text-muted">
                    Order ID: {order.order_id}
                  </small>
                </div>
              </div>

              <div className="text-center">
                <div className="fw-bold fs-6">
                  ₹{parsedRate.price}
                  <span className="ms-1 text-warning">
                    <i className="bi bi-lightning-charge-fill"></i>
                  </span>
                </div>
              </div>

              <div className="text-end">
                <div className="fw-semibold mb-1">
                  {renderStatus(order.transaction_status)}
                </div>
                <small className="text-muted"> {formattedDate}</small>
              </div>
            </div>
          );
        })
      )}
    </div>
  );
}
